import ZoneCoordGeoController from './zone.coord.geo.controller';
import zoneCoordGeoHtml from './zone.coord.geo.html';

export default {
	bindings: {
		modalInstance: '=',
		zone: '='
	},
	template: zoneCoordGeoHtml,
	controller: ZoneCoordGeoController
};
